import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Card, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BASE_URL } from "../../../constants";
import "../../../CommonCSS/SocietyCSS.css";
import EditAccountModal from './EditAccntMasterModal';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CashBankMaster = () => {

  const [formData, setFormData] = useState({
    acct_code: "",
    acct_name: "",
    acct_status: "",
    grp_cd: "",
    sub_grp_cd: "",
    type_of_acct: "M",
    ledger_type: "", 
    cont_person1: "", 
    cont_person_no1: "", 
    cont_person2: "", 
    cont_person_no2: "", 
    service_type: "", 
    gst_no: "", 
    pan_no: "", 
    off_addr1: "", 
    off_addr2: "", 
    off_phone: "", 
    off_email: "",
  });

  const [isEditable, setIsEditable] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [subGroupList, setSubGroupList] = useState([]);

  const [isLocked, setIsLocked] = useState(false);
  const [showsearchModal, setShowSearchModal] = useState(false);
  //const [isEditMode, setIsEditMode] = useState(false);

  // Fetch Groups from API
  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/ddl_fin_group`);
        setGroupList(res.data || []);
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };
    fetchGroups();
  }, []);

  // Fetch Sub-Groups when Group changes
  useEffect(() => {
    if (!formData.grp_cd) return;
    const fetchSubGroups = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/ddl_fin_sub_group`, {params: {p_GroupCd: formData.grp_cd }} );
        setSubGroupList(res.data || []);
      } catch (error) {
        console.error("Error fetching subgroups:", error);
      }
    };
    fetchSubGroups();
  }, [formData.grp_cd]);

  const handleNew = () => {

    setIsEditable(true);
    setFormData((prev) => ({ ...prev, 'acct_status': 'A' }));

  }


  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Save
  const handleSave = async () => {

    if (!formData.ledger_type || formData.ledger_type === '' ) {
      toast.error('Please select Ledger Type.');
      return;
    }

    if (!formData.acct_name || formData.acct_name === '' ) {
      toast.error('Please enter Account Name.');
      return;
    }

    if (!formData.acct_status || formData.acct_status === '' ) {
      toast.error('Please select Status.');
      return;
    }

    if (!formData.grp_cd || formData.grp_cd === '' ) {
      toast.error('Please select Group');
      return;
    }

    // if (formData.ledger_type === 'V') {
    //   if (!formData.bank_name || formData.bank_name === '') {
    //     toast.error('Please enter Bank Name.');
    //     return;
    //   }
    // }

    const confirmSave = window.confirm("Sure you want to save the record?");
    if (!confirmSave) return;

    const accntData = {
      accountData: formData,
    };

    try {
      const res = await axios.post(`${BASE_URL}/api/save_account_master`, accntData);
      if (res.data.message === "1") {
        toast.success("Account Master saved successfully!");
        reset_page();
      }
    } catch (error) {
      toast.error("Error saving Finance Account Master data!");
      console.error(error);
    }
  };

  const reset_page = () => {
    setFormData({
      acct_code: "",
      acct_name: "",
      acct_status: "",
      grp_cd: "",
      sub_grp_cd: "",
      type_of_acct: "M",
      ledger_type: "",
      cont_person1: "",
      cont_person_no1: "",
      cont_person2: "",
      cont_person_no2: "",
      service_type: "",
      gst_no: "",
      pan_no: "",
      off_addr1: "",
      off_addr2: "",
      off_phone: "",
      off_email: "",
    });

    setIsEditable(false);
    setIsLocked(false);
  }

  // Handle Clear
  const handleClear = () => {
    const confirmSave = window.confirm("Sure you want to clear the page?");
    if (!confirmSave) return;

    reset_page();
  };


    /// for Edit
  const handleCashBankRowSelect = async (selRow) => {

    setShowSearchModal(false);
    formData.acct_code = selRow.acct_code;

    const response = await axios.get(`${BASE_URL}/api/get_account_ByIds`, {params: { p_Acct_Code: selRow.acct_code}});

    setFormData({
      acct_code: response.data[0].acct_code,
      acct_name: response.data[0].acct_name,
      ledger_type: response.data[0].ledger_type,
      grp_cd: response.data[0].grp_cd,
      sub_grp_cd: response.data[0].sub_grp_cd,
      acct_status: response.data[0].acct_status,
      type_of_acct: response.data[0].type_of_acct,
      cont_person1: response.data[0].cont_person1,
      cont_person_no1: response.data[0].cont_person_no1,
      cont_person2: response.data[0].cont_person2,
      cont_person_no2: response.data[0].cont_person_no2,
      service_type: response.data[0].service_type,
      gst_no: response.data[0].gst_no,
      pan_no: response.data[0].pan_no,
      off_addr1: response.data[0].off_addr1,
      off_addr2: response.data[0].off_addr2,
      off_phone: response.data[0].off_phone,
      email_id: response.data[0].email_id,
      off_email: response.data[0].off_email,
    });

    //setSlots(response.data);

    setIsEditable(true);
    setIsLocked(true);
    //setIsEditMode(true);

  };

  return (
    <Container fluid className="p-3">
      <Card className="p-4 shadow-sm">
        {/* <h4 className="text-center mb-4">Finance Cash / Bank Master</h4> */}

        {/* --- Basic Details --- */}
        <Row className="mb-3">
          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>Type </InputGroup.Text>
              <Form.Select name="ledger_type" value={formData.ledger_type} onChange={handleChange} disabled={!isEditable || isLocked}>
                <option value="">-- Select Ledger Type --</option>
                <option value="G">GENERAL LEDGER</option>
                <option value="V">VENDOR LEDGER</option>
              </Form.Select>
            </InputGroup>
            {/* <Form.Label>Ledger Type:</Form.Label> */}

          </Col>

          <Col md={6}>
            <InputGroup>
              <InputGroup.Text>A/c Name </InputGroup.Text>
              {/* <Form.Label>Account Name:</Form.Label> */}
              <Form.Control type="text" name="acct_name" value={formData.acct_name.toLocaleUpperCase()}
                onChange={handleChange} disabled={!isEditable} />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>A/c Status </InputGroup.Text>
              <Form.Select name="acct_status" value={formData.acct_status} onChange={handleChange} disabled={!isEditable}>
                <option value="">-- Select Status --</option>
                <option value="A">ACTIVE</option>
                <option value="C">CLOSED</option>
              </Form.Select>
            </InputGroup>
            {/* <Form.Label>Account Status:</Form.Label> */}
          </Col>

        </Row>

        {/* --- Group Details --- */}
        <Row className="mb-3">
          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>Group </InputGroup.Text>
              <Form.Select name="grp_cd" value={formData.grp_cd} onChange={handleChange} disabled={!isEditable}>
                <option value="">-- Select Group --</option>
                {groupList.map((grp) => (
                  <option key={grp.grp_cd} value={grp.grp_cd}>
                    {grp.grp_desc}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
            {/* <Form.Label>Group:</Form.Label> */}
          </Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text>Sub Group </InputGroup.Text>
              <Form.Select name="sub_grp_cd" value={formData.sub_grp_cd} onChange={handleChange} disabled={!isEditable}>
                <option value="">-- Select Sub Group --</option>
                {subGroupList.map((sub) => (
                  <option key={sub.sub_grp_cd} value={sub.sub_grp_cd}>
                    {sub.sub_grp_desc}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
            {/* <Form.Label>Sub Group:</Form.Label> */}
          </Col>

          <Col md="5" className="d-flex justify-content-end">
            <Button variant="primary" className="me-2" style={{width: "100px"}} onClick={handleNew} disabled={isEditable}>New </Button>
            <Button variant="secondary" className="me-2" style={{width: "100px"}} onClick={handleClear} disabled={!isEditable}>Clear</Button>
            <Button variant="warning" className="me-2" style={{width: "100px"}} onClick={() => setShowSearchModal(true)} disabled={isEditable}>Edit</Button>
            {showsearchModal && (
            <EditAccountModal
              show={showsearchModal}
              handleClose={() => setShowSearchModal(false)}
              onRowSelect={handleCashBankRowSelect}
              // handleSave={handleSave}
            />
            )}
            <Button variant="success" style={{width: "100px"}} onClick={handleSave} disabled={!isEditable}>Save</Button>
          </Col>

        </Row>

        {/* --- Action Buttons --- */}
        {/* <Row className="mt-1 justify-content-end">
          <Col md="auto">
            <Button variant="primary" className="me-2" style={{width: "100px"}} onClick={handleNew} disabled={isEditable}>New </Button>
            <Button variant="secondary" className="me-2" style={{width: "100px"}} onClick={handleClear} disabled={!isEditable}>Clear</Button>
            <Button variant="warning" className="me-2" style={{width: "100px"}} onClick={() => setShowSearchModal(true)} disabled={isEditable}>Edit</Button>
            {showsearchModal && (
            <EditAccountModal
              show={showsearchModal}
              handleClose={() => setShowSearchModal(false)}
              onRowSelect={handleCashBankRowSelect}
            />
            )}
            <Button variant="success" style={{width: "100px"}} onClick={handleSave} disabled={!isEditable}>Save</Button>
          </Col>
        </Row> */}


        {/* --- Vendor Details: Only visible if Vendor --- */}
        {(formData.ledger_type === "V") && (
          <>
            <hr />
            <h5 className="mb-3 text-center text-primary">Vendor's Details</h5>

            <Row className="mb-3">
              <Col md={3}>
                <Form.Label>Contact Person Name 1:</Form.Label>
                <Form.Control
                  type="text"
                  name="cont_person1"
                  value={formData.cont_person1.toLocaleUpperCase()}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>
              <Col md={3}>
                <Form.Label>Contact Person 1 No:</Form.Label>
                <Form.Control
                  type="text"
                  name="cont_person_no1"
                  value={formData.cont_person_no1}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>

              <Col md={3}>
                <Form.Label>Contact Person Name 2:</Form.Label>
                <Form.Control
                  type="text"
                  name="cont_person2"
                  value={formData.cont_person2.toLocaleUpperCase()}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>
              <Col md={3}>
                <Form.Label>Contact Person 2 No:</Form.Label>
                <Form.Control
                  type="text"
                  name="cont_person_no2"
                  value={formData.cont_person_no2}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>

            </Row>

            <Row className="mb-3">
              <Col md={3}>
                <Form.Label>Address Line 1:</Form.Label>
                <Form.Control
                  type="text"
                  name="off_addr1"
                  value={formData.off_addr1}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>
              <Col md={3}>
                <Form.Label>Address Line 2:</Form.Label>
                <Form.Control
                  type="text"
                  name="off_addr2"
                  value={formData.off_addr2}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>

              <Col md={3}>
                <Form.Label>Office Phone No:</Form.Label>
                <Form.Control
                  type="text"
                  name="off_phone"
                  value={formData.off_phone}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>
              <Col md={3}>
                <Form.Label>eMail ID:</Form.Label>
                <Form.Control
                  type="email"
                  name="off_email"
                  value={formData.off_email}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>

            </Row>

            <Row className="mb-3">
              <Col md={3}>
                <Form.Label>Type of Service:</Form.Label>
                <Form.Control
                  type="text"
                  name="service_type"
                  value={formData.service_type.toLocaleUpperCase()}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>
              <Col md={3}>
                <Form.Label>GST No:</Form.Label>
                <Form.Control
                  type="text"
                  name="gst_no"
                  value={formData.gst_no}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>

              <Col md={3}>
                <Form.Label>PAN:</Form.Label>
                <Form.Control
                  type="text"
                  name="pan_no"
                  value={formData.pan_no}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>

            </Row>
          </>
        )}

      </Card>
    </Container>
  );
};

export default CashBankMaster;
